module.exports = __webpack_public_path__ + "static/media/misc-uploadPDF.8ffad571.svg";